export const customStyles = {
    control: (base, state) => ({
        ...base,
        background: "#FFF",
        borderRadius: 0,
        borderColor: state.isFocused ? "#ffae80" : "#e9ecef",
        boxShadow: state.isFocused ? "0 0 1.1px #ff5c00" : "",
        "&:hover": {
            borderColor: state.isFocused ? "#ffae80" : "#e9ecef",
            
        }
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#ff7426" : "#FFF",
        ':active': {
            backgroundColor: state.isSelected ? "#ff7426" : "#ff7426",
            color: state.isSelected ? "#FFF" : "#FFF"
        },
        '&:hover': {
            backgroundColor: state.isSelected ? "#ff7426" : "#ff7426",
            color: state.isSelected ? "#FFF" : "#FFF"
        }
    })
}
